/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Too_Many_Attempts_DescriptionInputs */

const en_toast_too_many_attempts_description = /** @type {(inputs: Toast_Too_Many_Attempts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've made too many attempts. Please wait a moment and try again.`)
};

const nl_toast_too_many_attempts_description = /** @type {(inputs: Toast_Too_Many_Attempts_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U heeft te veel pogingen gedaan. Wacht even en probeer het opnieuw.`)
};

/**
* | output |
* | --- |
* | "You've made too many attempts. Please wait a moment and try again." |
*
* @param {Toast_Too_Many_Attempts_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_too_many_attempts_description = /** @type {((inputs?: Toast_Too_Many_Attempts_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Too_Many_Attempts_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_too_many_attempts_description(inputs)
	return en_toast_too_many_attempts_description(inputs)
});